import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";
import { handleEmit } from "src/contract-logic/logic";
import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/TravaNFTSellABI.json";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_SELL_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, NFT_SELL_ADDRESS);
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, NFT_SELL_ADDRESS);
  }
  return contractSender;
}

async function createSale(dispatch, tokenId, price, accountAddress) {
  const emit = getContractSender().methods.createSale(tokenId, price).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Sell NFT");
  return await emit;
}

async function makeSaleOrder(dispatch, tokenId, price, accountAddress) {
  const emit = getContractSender().methods.makeOrder(tokenId, price).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Buy NFT");
  return await emit;
}

async function cancelSale(dispatch, tokenId, accountAddress) {
  const emit = getContractSender().methods.cancelSale(tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Cancel sale");
  await emit;
}

async function getTokenOfOwnerBalance(ownerAddress) {
  const res = await getContractReader().methods.getTokenOfOwnerBalance(ownerAddress).call();
  return parseInt(res);
}

async function getTokenOnSaleCount() {
  const res = await getContractReader().methods.getTokenOnSaleCount().call();
  return parseInt(res);
}

async function getTokenOrder(tokenId) {
  const res = await getContractReader().methods.getTokenOrder(tokenId).call();
  return {
    price: BigNumber(res.price).dividedBy(BASE18).toNumber(),
    seller: res.nftSeller,
  };
}

async function editPrice(dispatch, tokenId, price, accountAddress) {
  const emit = getContractSender().methods.editPrice(tokenId, price).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Edit price");
  await emit;
}

export default {
  ABI,
  ADDRESS: NFT_SELL_ADDRESS,
  createSale,
  makeSaleOrder,
  getTokenOfOwnerBalance,
  getTokenOnSaleCount,
  getTokenOrder,
  cancelSale,
  editPrice,
};
